import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { toast } from "sonner";

export const TemplateMappingDialog = ({ open, row, roomTypeId, items, onOpenChange, onResolved }) => {
  const [itemId, setItemId] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setItemId("");
  }, [open, row?.id]);

  const resolve = async () => {
    if (!itemId || !row) {
      toast.error("Choose an active Linen Item Master record");
      return;
    }
    setBusy(true);
    try {
      await api.put(`/room-types/${roomTypeId}/linen-template/${row.id}/resolve`, {
        item_id: itemId,
      });
      toast.success("Template mapping resolved");
      onOpenChange(false);
      onResolved();
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="resolve-template-mapping-dialog">
        <DialogHeader>
          <DialogTitle>Resolve template mapping</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="text-sm text-slate-600" data-testid="orphaned-template-label">
            {row?.legacy_label || "Unresolved template row"}
          </div>
          <div>
            <Label>Linen Item Master</Label>
            <Select value={itemId} onValueChange={setItemId}>
              <SelectTrigger className="mt-1 h-11" data-testid="resolve-template-item-select">
                <SelectValue placeholder="Choose active item" />
              </SelectTrigger>
              <SelectContent>
                {items.filter(item => item.active !== false).map(item => (
                  <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="resolve-template-cancel">
            Cancel
          </Button>
          <Button
            onClick={resolve}
            disabled={busy}
            className="bg-slate-900 text-white hover:bg-slate-800"
            data-testid="resolve-template-save"
          >
            Resolve Mapping
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};